import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import axios from "axios";
import { Api_Url } from "../../../../utils/ApiUrl";

const Wallets = ({
  walletFormErrors,
  setWalletFormErrors,
  walletformData,
  setWalletFormData,
  tokens,
}) => {
  // Add validation effect
  useEffect(() => {
    const initialPlatformAmount = parseFloat(
      walletformData.initialPlatformAmount || "0"
    );
    const platformFeeThreshold = parseFloat(
      walletformData.platformFeeThreshold || "0"
    );

    // Clear existing errors first
    const clearedErrors = { ...walletFormErrors };

    // Rule 1: If Initial Platform Amount > 0 but Platform Fee Threshold is 0
    if (initialPlatformAmount > 0 && platformFeeThreshold === 0) {
      clearedErrors.platformFeeThreshold =
        "Platform Fee Threshold is required when Initial Platform Amount is greater than 0";
    } else if (
      walletFormErrors.platformFeeThreshold ===
      "Platform Fee Threshold is required when Initial Platform Amount is greater than 0"
    ) {
      clearedErrors.platformFeeThreshold = "";
    }

    // Rule 2: If Initial Platform Amount > Platform Fee Threshold (both > 0)
    if (
      initialPlatformAmount > 0 &&
      platformFeeThreshold > 0 &&
      initialPlatformAmount > platformFeeThreshold
    ) {
      clearedErrors.initialPlatformAmount =
        "Initial Platform Amount cannot be greater than Platform Fee Threshold";
    } else if (
      walletFormErrors.initialPlatformAmount ===
      "Initial Platform Amount cannot be greater than Platform Fee Threshold"
    ) {
      clearedErrors.initialPlatformAmount = "";
    }

    setWalletFormErrors(clearedErrors);
  }, [
    walletformData.initialPlatformAmount,
    walletformData.platformFeeThreshold,
  ]);

  // Handle input changes
  const handleWalletChange = (e) => {
    const { name, value } = e.target;
    setWalletFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (walletFormErrors[name]) {
      setWalletFormErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  // Toggle token selection - NOW USING ID
  const toggleToken = (tokenId) => {
    setWalletFormData((prev) => {
      const currentTokens = prev.acceptedPaymentTokens || [];
      const newTokens = currentTokens.includes(tokenId)
        ? currentTokens.filter((id) => id !== tokenId)
        : [...currentTokens, tokenId];

      return {
        ...prev,
        acceptedPaymentTokens: newTokens,
      };
    });

    if (walletFormErrors.acceptedPaymentTokens) {
      setWalletFormErrors((prev) => ({
        ...prev,
        acceptedPaymentTokens: "",
      }));
    }
  };

  // Remove token - NOW USING ID
  const removeToken = (tokenId) => {
    setWalletFormData((prev) => ({
      ...prev,
      acceptedPaymentTokens: prev.acceptedPaymentTokens.filter(
        (id) => id !== tokenId
      ),
    }));
  };

  // Helper function to get selected tokens with full details
  const getSelectedTokensDetails = () => {
    return walletformData.acceptedPaymentTokens
      ?.map((tokenId) => tokens.find((t) => t._id === tokenId))
      .filter(Boolean); // Remove any undefined values
  };

  return (
    <>
      <div className="parentsteps">
        <section className="foursteps latestmsggg">
          <div className="newinner mywalletaddress">
            {/* Project Fund Wallet */}
            <h2>
              Project's Funds Wallet Address <span className="redspan">*</span>
            </h2>
            <input
              type="text"
              name="projectFundWallet"
              value={walletformData.projectFundWallet}
              onChange={handleWalletChange}
              placeholder="Enter Project's Funds Wallet Address"
              className={
                walletFormErrors.projectFundWallet ? "error-input" : ""
              }
            />
            {walletFormErrors.projectFundWallet && (
              <span className="error-text">
                {walletFormErrors.projectFundWallet}
              </span>
            )}

            {/* Platform Fee Wallet */}
            <h2>
              Platform Fee Wallet Address<span className="redspan">*</span>
            </h2>
            <input
              type="text"
              name="platformFeeWallet"
              value={walletformData.platformFeeWallet}
              onChange={handleWalletChange}
              placeholder="Platform Fee Wallet Address"
              className={
                walletFormErrors.platformFeeWallet ? "error-input" : ""
              }
            />
            {walletFormErrors.platformFeeWallet && (
              <span className="error-text">
                {walletFormErrors.platformFeeWallet}
              </span>
            )}

            {/* Owner Wallet */}
            <h2>
              Owner's Wallet Address <span className="redspan">*</span>
            </h2>
            <input
              type="text"
              name="ownerWallet"
              value={walletformData.ownerWallet}
              onChange={handleWalletChange}
              placeholder="Owner's Wallet Address"
              className={walletFormErrors.ownerWallet ? "error-input" : ""}
            />
            {walletFormErrors.ownerWallet && (
              <span className="error-text">{walletFormErrors.ownerWallet}</span>
            )}

            {/* Buyback Burn Wallet */}
            <h2>
              Lock Wallet Address <span className="redspan">*</span>
            </h2>
            <input
              type="text"
              name="buybackBurnWallet"
              value={walletformData.buybackBurnWallet}
              onChange={handleWalletChange}
              placeholder="Lock wallet Address"
              className={
                walletFormErrors.buybackBurnWallet ? "error-input" : ""
              }
            />
            {walletFormErrors.buybackBurnWallet && (
              <span className="error-text">
                {walletFormErrors.buybackBurnWallet}
              </span>
            )}

            {/* Accepted Payment Tokens */}
            <h2>
              Accepted Payment Tokens<span className="redspan">*</span>
            </h2>
            <div className="dropdown_projects">
              <Dropdown>
                <Dropdown.Toggle
                  variant="success"
                  id="dropdown-basic"
                  className={
                    walletFormErrors.acceptedPaymentTokens ? "error-input" : ""
                  }
                >
                  {walletformData.acceptedPaymentTokens?.length === 0 ? (
                    "Select Tokens"
                  ) : (
                    <div className="coininnner">
                      {getSelectedTokensDetails()?.map((token) => (
                        <div key={token._id} className="token-chip">
                          <img
                            src={token?.imageUrl}
                            className="imgg"
                            alt={token.tokenSymbol}
                          />
                          <h4>{token.tokenSymbol}</h4>

                          <svg
                            onClick={(e) => {
                              e.stopPropagation();
                              removeToken(token._id);
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            style={{ cursor: "pointer", marginLeft: "6px" }}
                          >
                            <path
                              d="M9 3L3 9"
                              stroke="#939FA3"
                              strokeWidth="1.2"
                              strokeLinecap="square"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M3 3L9 9"
                              stroke="#939FA3"
                              strokeWidth="1.2"
                              strokeLinecap="square"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      ))}
                    </div>
                  )}

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="7"
                    viewBox="0 0 15 7"
                    fill="none"
                    style={{ marginLeft: "12px" }}
                  >
                    <path
                      d="M0 0L2.59464e-07 2.97056L7.23333 7L7.23333 4.02943L0 0Z"
                      fill="black"
                    />
                    <path
                      d="M14.4648 0L14.4648 2.97056L7.23151 7L7.23151 4.02943L14.4648 0Z"
                      fill="black"
                    />
                  </svg>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <div className="main_dev_coin">
                    {tokens.map((token) => (
                      <div key={token._id} className="coins_mainsss">
                        <div
                          className="custom-checkbox"
                          onClick={() => toggleToken(token._id)}
                        >
                          {walletformData.acceptedPaymentTokens?.includes(
                            token._id
                          ) && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="white"
                              strokeWidth="3"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                          )}
                        </div>

                        <img
                          src={token.imageUrl}
                          className="imgcoinssmall"
                          alt={token.tokenSymbol}
                        />
                        <h3>{token.tokenSymbol}</h3>
                      </div>
                    ))}
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            {walletFormErrors.acceptedPaymentTokens && (
              <span className="error-text">
                {walletFormErrors.acceptedPaymentTokens}
              </span>
            )}

            {/* Platform Fee Threshold */}
            <h2 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              Platform Fee Threshold
              <span className="tooltip-wrapper">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M6.4165 9.91602H7.58317V6.41602H6.4165V9.91602ZM6.99984 5.24935C7.16511 5.24935 7.30375 5.19335 7.41575 5.08135C7.52775 4.96935 7.58356 4.8309 7.58317 4.66602C7.58317 4.50074 7.52717 4.36229 7.41517 4.25068C7.30317 4.13907 7.16473 4.08307 6.99984 4.08268C6.83456 4.08268 6.69612 4.13868 6.5845 4.25068C6.47289 4.36268 6.41689 4.50113 6.4165 4.66602C6.4165 4.83129 6.4725 4.96993 6.5845 5.08193C6.6965 5.19393 6.83495 5.24974 6.99984 5.24935ZM6.99984 12.8327C6.19289 12.8327 5.43456 12.6795 4.72484 12.373C4.01512 12.0666 3.39775 11.651 2.87275 11.1264C2.34775 10.6014 1.93223 9.98407 1.62617 9.27435C1.32012 8.56463 1.16689 7.80629 1.1665 6.99935C1.1665 6.1924 1.31973 5.43407 1.62617 4.72435C1.93262 4.01463 2.34814 3.39727 2.87275 2.87227C3.39775 2.34727 4.01512 1.93174 4.72484 1.62568C5.43456 1.31963 6.19289 1.1664 6.99984 1.16602C7.80678 1.16602 8.56511 1.31924 9.27484 1.62568C9.98456 1.93213 10.6019 2.34765 11.1269 2.87227C11.6519 3.39727 12.0676 4.01463 12.3741 4.72435C12.6805 5.43407 12.8336 6.1924 12.8332 6.99935C12.8332 7.80629 12.6799 8.56463 12.3735 9.27435C12.0671 9.98407 11.6515 10.6014 11.1269 11.1264C10.6019 11.6514 9.98456 12.0672 9.27484 12.3736C8.56511 12.68 7.80678 12.8331 6.99984 12.8327ZM6.99984 11.666C8.30261 11.666 9.40609 11.2139 10.3103 10.3098C11.2144 9.4056 11.6665 8.30213 11.6665 6.99935C11.6665 5.69657 11.2144 4.5931 10.3103 3.68893C9.40609 2.78477 8.30261 2.33268 6.99984 2.33268C5.69706 2.33268 4.59359 2.78477 3.68942 3.68893C2.78525 4.5931 2.33317 5.69657 2.33317 6.99935C2.33317 8.30213 2.78525 9.4056 3.68942 10.3098C4.59359 11.2139 5.69706 11.666 6.99984 11.666Z"
                    fill="#02171D"
                  />
                </svg>
                <span className="tooltip-text">
                  The total amount raised in the private sale that must be
                  reached before the platform starts charging its platform fee.
                  Once the threshold is reached, the standard platform fee
                  percentage is deducted from each subsequent purchase (10%).
                </span>
              </span>
            </h2>
            <div className="doller_div">
              <span className="doller">$</span>
              <input
                type="text"
                name="platformFeeThreshold"
                value={walletformData.platformFeeThreshold}
                onChange={handleWalletChange}
                placeholder="Platform Fee Threshold"
                className={
                  walletFormErrors.platformFeeThreshold ? "error-input" : ""
                }
              />
            </div>
            {walletFormErrors.platformFeeThreshold && (
              <span className="error-text">
                {walletFormErrors.platformFeeThreshold}
              </span>
            )}

            {/* Initial Platform Amount */}
            <h2 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              Initial Platfrom Amount
              <span className="tooltip-wrapper">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M6.4165 9.91602H7.58317V6.41602H6.4165V9.91602ZM6.99984 5.24935C7.16511 5.24935 7.30375 5.19335 7.41575 5.08135C7.52775 4.96935 7.58356 4.8309 7.58317 4.66602C7.58317 4.50074 7.52717 4.36229 7.41517 4.25068C7.30317 4.13907 7.16473 4.08307 6.99984 4.08268C6.83456 4.08268 6.69612 4.13868 6.5845 4.25068C6.47289 4.36268 6.41689 4.50113 6.4165 4.66602C6.4165 4.83129 6.4725 4.96993 6.5845 5.08193C6.6965 5.19393 6.83495 5.24974 6.99984 5.24935ZM6.99984 12.8327C6.19289 12.8327 5.43456 12.6795 4.72484 12.373C4.01512 12.0666 3.39775 11.651 2.87275 11.1264C2.34775 10.6014 1.93223 9.98407 1.62617 9.27435C1.32012 8.56463 1.16689 7.80629 1.1665 6.99935C1.1665 6.1924 1.31973 5.43407 1.62617 4.72435C1.93262 4.01463 2.34814 3.39727 2.87275 2.87227C3.39775 2.34727 4.01512 1.93174 4.72484 1.62568C5.43456 1.31963 6.19289 1.1664 6.99984 1.16602C7.80678 1.16602 8.56511 1.31924 9.27484 1.62568C9.98456 1.93213 10.6019 2.34765 11.1269 2.87227C11.6519 3.39727 12.0676 4.01463 12.3741 4.72435C12.6805 5.43407 12.8336 6.1924 12.8332 6.99935C12.8332 7.80629 12.6799 8.56463 12.3735 9.27435C12.0671 9.98407 11.6515 10.6014 11.1269 11.1264C10.6019 11.6514 9.98456 12.0672 9.27484 12.3736C8.56511 12.68 7.80678 12.8331 6.99984 12.8327ZM6.99984 11.666C8.30261 11.666 9.40609 11.2139 10.3103 10.3098C11.2144 9.4056 11.6665 8.30213 11.6665 6.99935C11.6665 5.69657 11.2144 4.5931 10.3103 3.68893C9.40609 2.78477 8.30261 2.33268 6.99984 2.33268C5.69706 2.33268 4.59359 2.78477 3.68942 3.68893C2.78525 4.5931 2.33317 5.69657 2.33317 6.99935C2.33317 8.30213 2.78525 9.4056 3.68942 10.3098C4.59359 11.2139 5.69706 11.666 6.99984 11.666Z"
                    fill="#02171D"
                  />
                </svg>
                <span className="tooltip-text">
                  The initial amount (in USD) that is allocated to the platform
                  before applying the regular platform fee logic. This amount is
                  taken first from the funds raised in the sale, and only after
                  it is fully covered does the sale continue according to the
                  platform fee threshold and standard distribution rules.
                </span>
              </span>
            </h2>
            <div className="doller_div">
              <span className="doller">$</span>
              <input
                type="text"
                name="initialPlatformAmount"
                value={walletformData.initialPlatformAmount}
                onChange={handleWalletChange}
                placeholder="Initial Platfrom Amount"
                className={
                  walletFormErrors.initialPlatformAmount ? "error-input" : ""
                }
              />
            </div>
            {walletFormErrors.initialPlatformAmount && (
              <span className="error-text">
                {walletFormErrors.initialPlatformAmount}
              </span>
            )}
          </div>
        </section>
      </div>
    </>
  );
};

export default Wallets;
